import React from 'react';
import SearchPhotos from '../../components/SearchPhotos';

const Search = () => {

    document.title = "Veta - Search";

    return (
        <>
            <SearchPhotos />
        </>
    )
}

export default Search;